
// Definición de defaults

export const defaultPuesto: PuestoProps = {
    idPuesto:       0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface PuestoProps {
    idPuesto:       number;
    descripcion:    string;
    activo:         boolean;
}